import React from "react";
import Image from "next/image";
import BenefitCard from "./BenefitCard";

interface ServeProps {
  data: {
    title: string;
    points: {
      id: number;
      title: string;
      text: string;
    }[];
  };
}

const Benefits: React.FC<ServeProps> = ({ data }) => {
  return (
    <div className="bg-background-dark text-white relative overflow-hidden">
      <section className="bg-background-white xl:py-25 md:py-[80px] py-[56px]">
        {/* Shapes */}
        <div className="banner-shape-1 absolute top-[0px] left-0 z-[1] w-[50%] md:w-[40%]">
          <Image
            src="/images/banner-left-layer-mobile.png"
            alt="Banner Shape"
            width={571}
            height={571}
            className="w-full h-full md:hidden"
          />
          <Image
            src="/images/banner-left-layer-tablet.png"
            alt="Banner Shape"
            width={571}
            height={571}
            className="w-full h-full hidden md:block lg:hidden"
          />
          <Image
            src="/images/banner-left-layer-desktop.png"
            alt="Banner Shape"
            width={571}
            height={571}
            className="w-full h-full hidden lg:block"
          />
        </div>
        <div className="banner-shape-1 absolute bottom-0 right-0 z-[-1] ">
          <Image
            src="/images/banner-right-layer-mobile.png"
            alt="Banner Shape"
            width={471}
            height={471}
            className="object-cover w-full h-full md:hidden"
          />
          <Image
            src="/images/banner-right-layer-tablet.png"
            alt="Banner Shape"
            width={471}
            height={471}
            className="object-cover w-full h-full hidden md:block lg:hidden"
          />
          <Image
            src="/images/banner-right-layer-desktop.png"
            alt="Banner Shape"
            width={471}
            height={471}
            className="object-cover w-full h-full hidden lg:block"
          />
        </div>

        <div className="container mx-auto px-4 relative z-10">
          <h2 className="text-heading-1 font-bold text-center capitalize max-w-[1230px] mx-auto">
            {data?.title}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-[30px] mt-[40px]">
            {data?.points?.map((card: any, index: number) => (
              <BenefitCard
                key={index}
                title={card?.title}
                description={card?.text}
              />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};
export default Benefits;
